module.exports = __webpack_public_path__ + "static/media/prio3.076c998e.jpg";